import { React } from 'react';
import remove from '../../Images/Common/remove.svg';
import './style.scss';
const ErrorImage = ({
  errorMessage,
  containerStyle,
  wrapperClass,
  errorSubMessage,
}) => {
  return (
    <div
      className={`error_main_conatiner ${wrapperClass ? wrapperClass : ''}`}
      style={{ ...containerStyle }}
    >
      <div className="content">
        <div className="loading_image_container">
          <img src={remove} alt="errorImage" />
        </div>
        <div className="waiting_title">{errorMessage}</div>
        <div className="waiting_subTitle">{errorSubMessage}</div>
      </div>
    </div>
  );
};
export default ErrorImage;
